module.exports = __webpack_public_path__ + "img/cartoes.b6ad613f.png";